import useIsMobile from "../hooks/useIsMobile";

// import Lottie from "lottie-react";
import AnimatedContent from "./animatedContent/AnimatedContent";

import "./ThirdPage.css";
// import SplitText from "../Components/SplitText/SplitText";
import VideoPlayer from "../Components/VideoPlayer/index";
const data = "https://brevis-media-res.s3.us-west-1.amazonaws.com/website/mp4/data1.mp4";

export const openTalk = () => {
  window.open("https://form.typeform.com/to/lduiliob", "_blank");
};

function ThirdPage() {
  const { isMobile } = useIsMobile();

  return (
    <div className="thirdPage" id="thirdPage">
      <div>
        {/* <SplitText
          text="The {Black Box} Dilemma"
          className="pageTitle"
          delay={100}
          duration={0.6}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="center"
          onLetterAnimationComplete={() => {}}
        /> */}
        <AnimatedContent
          type="bottom"
          id={"Black"}
          key={"Black"}
          duration={800}
        >
          <div className="pageTitle" key="Black2">
            The <span className="black_box">{"{Black Box}"}</span> Dilemma
          </div>
        </AnimatedContent>
        {/* The <span className="black_box">{"{Black Box}"}</span> Dilemma */}
      </div>
      <div className="title2">
        Every advanced dApp faces an impossible trade-off
      </div>
      {isMobile ? (
        <div>
          <div className="des">
          Keep computations on-chain: trustless but severely limited. Move them off-chain: powerful but unverifiable. 
          <div className="des" style={{ marginTop: 26 }}>
          Every complex application is forced to choose: stay simple enough to verify, or run it in the dark and ask users to trust you.
          </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="des">
            Keep computations on-chain: trustless but severely limited. Move
          </div>
          <div className="des">
            them off-chain: powerful but unverifiable. 
          </div>
          <div className="des" style={{ marginTop: 26 }}>
            Every complex application is forced to choose: stay simple enough to
          </div>
          <div className="des">
            verify, or run it in the dark and ask users to trust you.
          </div>
        </div>
      )}
      

      <div
        style={{
          // marginTop: 62,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* <div style={{ width: 600 }}>
          <Lottie animationData={animationData} autoplay={true} loop={true} />
        </div> */}

        <div
          style={{ width: isMobile ? 254 : 600, marginTop: isMobile ? 45 : 0 }}
        >
          <VideoPlayer src={data} />
        </div>
      </div>
    </div>
  );
}

export default ThirdPage;
